import Vue from 'vue'
import VueJWT from 'vuejs-jwt'
let JwtOption = {
    signKey : 'XkgXys83uA-3nwt9r3QPoalndVLWf_np_3H37Y6oKeY',
    storage  : 'localStorage',
    keyName  : 'com.dgmong.eotadmtoken',
    ignoreExpiration : false,       // set true to ignore expiration date
    ignoreNotBefore  : false,       // set true to ignore 'not before' date
}

Vue.use(VueJWT, JwtOption)
export default {
    methods:{
        getStorageToken() { // 토큰 가져오기
            let token = this.$jwt.getToken();
            var regex = /"/gi;
            if(!token){
                return null;
            }
            let jwtToken = token.replace(regex,'');
            return jwtToken
        },
        performAutoLogin: function(token, path = ''){ // 토큰이 로컬스토리지에 담겼을 시 사용
            // this.$api.$handler.authHeader(token);
            if(path !== "") {
                this.$router.push({path: path});
            }
            this.UpdateSiteCheck();
            this.UpdateUserCheck(path);

        },

        UpdateUserCheck: function(path){
            if(Vue.$jwt.hasToken()) {
                let jwtToken = this.getStorageToken();
                let tokenObject = Vue.$jwt.decode(jwtToken, JwtOption.signKey);
                let params = {a_container_type : 'profile', a_container_id: tokenObject.mb_no};
                this.$api.$common.getFile(params).then( res => res.Data.Result).then(res => {
                    if(res.Info.status && res.List.length > 0){
                        let file = res.List[0];
                        file.url = file.thumb_url;
                        file.name = file.org_name;
                        this.$store.dispatch('common/initUserImg', {info : file} );
                    }
                });
            }

            /*params = {m_type : 'admin'}
            this.$api.$auth.getMember(params).then( res => res.Data.Result).then(res => {
                if(res.Info.status === true){
                    this.$store.dispatch('userInfo/initUserInfo', {info : res.List[0]} );
                    if(path !== "") {
                        this.$router.push({path: path});
                    }
                }
            }, () => {
                console.log('error');
                this.localLogout();
            })*/
        },
        UpdateSiteCheck: function(){
            let params = {a_container_type : 'siteLogo'};
            this.$api.$common.getFile(params).then( res => res.Data.Result).then(res => {
                if(res.Info.status){
                    if(res.List[0]) {
                        let file = res.List[0];
                        file.url = file.thumb_url;
                        file.name = file.org_name;
                        this.$store.dispatch('common/initSiteLogo', {info : file} );
                    }
                }
            });
            this.$api.$common.getConfigInfo().then( res => res.Data.Result).then(res => {
                this.$store.dispatch('common/initSiteInfo', {info : res.List[0]} );
            })
        },
        localLogout: function(token){ // 토큰이 로컬스토리지에 담겼을 시 사용
            this.$localStorage.clear(true);
            this.$route.query.first = false;
            this.$router.push({path: "/auth"});
        }
    }
}
